import { ref } from 'vue';

/**
 * A section the visitor asked to see from somewhere that is not the landing
 * page — `SiteHeader`/`SiteFooter` mounted on `/news`, say, where "Research"
 * means "go home, then scroll to `#research`" rather than an in-page scroll.
 *
 * A ref at module scope rather than a prop threaded down from `App.vue`:
 * `SiteHeader` and `SiteFooter` are mounted independently by three different
 * pages, and `LandingScreen` is the one place that ever needs to *read* this
 * — a tiny shared singleton is the whole mechanism, the same shape
 * `state/deep-link.ts` and `state/news-route.ts` already use for "one fact,
 * read in one place, written from several."
 */
export const pendingAnchor = ref<string | null>(null);
